import { usePostHog } from "posthog-js/react";
import { useRef } from "react";

export function useTrackLevelChange() {
  const posthog = usePostHog();
  const previousLevel = useRef<number | null>(null);

  const trackLevelChange = (level: number | null) => {
    if (level !== previousLevel.current) {
      posthog.capture("level_changed", {
        level: level,
      });
      previousLevel.current = level;
    }
  };

  return trackLevelChange;
} 